module.exports = __webpack_public_path__ + "static/media/thinking.8a69ab03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/thinking.svg
// module id = 2463
// module chunks = 0